import * as React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Tabs as MuiTabs, TabsProps } from '@material-ui/core';
import { tabsRoot } from 'ui/Tabs/tabsCssDefs';

interface Props extends TabsProps {
  contained?: boolean;
}
/**
 * A styled Tabs component. The contained prop will render a bottom border
 * @see {@link https://material-ui.com/api/tabs/} Material API docs for props
 */
const Tabs: React.FunctionComponent<Props> = ({ children, className, contained, ...rest }) => {
  return (
    <MuiTabs
      className={className}
      css={tabsRoot(contained)}
      indicatorColor="primary"
      {...rest}
      data-testid="jump-bar-items"
    >
      {children}
    </MuiTabs>
  );
};

export default Tabs;
